var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 5,
    y: 5,
    fill: "#D1FADF",
    rx: 28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 5,
    y: 5,
    stroke: "#ECFDF3",
    strokeWidth: 10,
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#039855",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m27.75 33 3.5 3.5 7-7m6.416 3.5c0 6.443-5.223 11.667-11.666 11.667S21.333 39.443 21.333 33 26.556 21.333 33 21.333c6.443 0 11.666 5.224 11.666 11.667"
  })));
};
export default SvgCheckmark;